import { inject, Injectable, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AvailabilityNotificationCreateCommandResult, AvailabilityNotificationDeleteCommandResult, ProductIdentifierDto
} from '../../INTEGRA_Shop_Client';
import { IAvailabilityNotificationService, IAvailabilityNotificationServiceToken } from './availability-notification-service.interface';
import { IAvailabilityNotificationApiService, IAvailabilityNotificationApiServiceToken } from '../../api/availability-notification/availability-notification-api-service.interface';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityNotificationService implements IAvailabilityNotificationService {
  private readonly availabilityNotificationApiService: IAvailabilityNotificationApiService;

  public constructor() {
    this.availabilityNotificationApiService = inject(IAvailabilityNotificationApiServiceToken);
  }

  public availabilityNotificationCreate(productList: ProductIdentifierDto[]): Observable<AvailabilityNotificationCreateCommandResult> {
    return this.availabilityNotificationApiService.availabilityNotificationCreate(productList);
  }

  public availabilityNotificationDelete(productList: ProductIdentifierDto[]): Observable<AvailabilityNotificationDeleteCommandResult> {
    return this.availabilityNotificationApiService.availabilityNotificationDelete(productList);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AvailabilityNotificationServiceProvider: Provider[] = [
  { provide: IAvailabilityNotificationServiceToken, useExisting: AvailabilityNotificationService }
];
